/* eslint-disable no-loop-func */
import type { PartnerFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

const getRelatedPartnerName = (instructorId: string, partners?: Array<PartnerFragment> | null) => {
  if (!partners || !partners.length) {
    return null;
  }

  let relatedPartnerName = null;

  for (let i = 0; i < partners.length; i += 1) {
    if (relatedPartnerName) {
      break;
    } else {
      partners?.[i]?.instructorIds?.forEach((partnerInstructorId) => {
        if (partnerInstructorId === instructorId) {
          relatedPartnerName = partners?.[i]?.name;
        }
      });
    }
  }

  return relatedPartnerName;
};

export default getRelatedPartnerName;
